(() => {
  const movePaymentTerms = () => {
    const paymentForm = document.querySelector('form.installment.caption-large');
    const addToCartGroup = document.querySelector('.product-form__buttons');
    if (!paymentForm || !addToCartGroup || addToCartGroup.parentNode === null) return;
    if (paymentForm.nextElementSibling === addToCartGroup.nextElementSibling) return; // already moved?
    addToCartGroup.parentNode.insertBefore(paymentForm, addToCartGroup.nextSibling);
  };

  document.addEventListener('DOMContentLoaded', movePaymentTerms);
  document.addEventListener('variant:change', movePaymentTerms);
  document.addEventListener('shopify:section:load', movePaymentTerms);
})();
